import Loadable from "react-loadable";

import { Loading } from "../../common/navigation";

const Docusignpkkps = Loadable({
  loader: () => import("./components/docusignpkkps"),
  loading: Loading,
});
const DocusignInterview = Loadable({
  loader: () => import("./components/docusign_interview"),
  loading: Loading,
});

export const routes = [
  {
    path: "/docusignpkkps",
    exact: true,
    name: "docusignpkkps",
    component: Docusignpkkps,
  },
  {
    path: "/docusign_interview",
    exact: true,
    name: "docusign_interview",
    component: DocusignInterview,
  },
];
